var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 142,
  height: 116,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__a)",
  d: "M57.64 89.571a98.641 98.641 0 0 0 31.437-45.762A101.269 101.269 0 0 0 94.062 0l46.526 26.766a101.778 101.778 0 0 1-5.03 43.068A98.483 98.483 0 0 1 103.583 116L57.641 89.571Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__b)",
  d: "M4.064 57.73a72.505 72.505 0 0 1 31.728-40.058l34.85 20.052A72.348 72.348 0 0 0 39.206 77.58a78.429 78.429 0 0 0-4.087 20.77L0 78.165a79.646 79.646 0 0 1 4.064-20.433Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__a",
  x1: 99.384,
  x2: 99.384,
  y1: 88.201,
  y2: 23.375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0C6DEB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#069EB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00CD80"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__b",
  x1: 35.321,
  x2: 35.321,
  y1: 89.347,
  y2: 20.209,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0C6DEB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#069EB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00CD80"
})))));
export { SvgLogo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQyIiBoZWlnaHQ9IjExNiIgdmlld0JveD0iMCAwIDE0MiAxMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01Ny42NDA2IDg5LjU3MUM3Mi4yODQ2IDc3LjY0MTMgODMuMTk1NiA2MS43NTggODkuMDc2OSA0My44MDg3QzkzLjkzNTkgMjkuNzQ5MiA5NS42Mzc5IDE0Ljc5MTggOTQuMDYxOCAwTDE0MC41ODggMjYuNzY1OEMxNDIuMDI0IDQxLjMxNjMgMTQwLjMwOSA1Ni4wMDU3IDEzNS41NTggNjkuODMzNUMxMjkuNjA2IDg3Ljk5OTQgMTE4LjQ5NiAxMDQuMDQxIDEwMy41ODMgMTE2TDU3LjY0MDYgODkuNTcxWiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzkwOTRfMjM1NDcyKSIvPgo8cGF0aCBkPSJNNC4wNjQyNyA1Ny43MzA2QzkuNDI4MzggNDAuOTY5NiAyMC43MDU0IDI2LjczMTcgMzUuNzkyNSAxNy42NzE4TDcwLjY0MTkgMzcuNzIzNkM1NS42OTMyIDQ2Ljc3NjQgNDQuNTI2NiA2MC45MzQxIDM5LjIwNTYgNzcuNTgwNEMzNi45MTEgODQuMjg3NCAzNS41MzYyIDkxLjI3NDUgMzUuMTE4OSA5OC4zNTA4Vjk4LjM1MDhMMCA3OC4xNjQyQzAuNDU0MjMgNzEuMjA0NCAxLjgyMDY3IDY0LjMzNDUgNC4wNjQyNyA1Ny43MzA2VjU3LjczMDZaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXJfOTA5NF8yMzU0NzIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfOTA5NF8yMzU0NzIiIHgxPSI5OS4zODM2IiB5MT0iODguMjAxMyIgeDI9Ijk5LjM4MzYiIHkyPSIyMy4zNzUxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMwQzZERUIiLz4KPHN0b3Agb2Zmc2V0PSIwLjQ5IiBzdG9wLWNvbG9yPSIjMDY5RUI1Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwQ0Q4MCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfOTA5NF8yMzU0NzIiIHgxPSIzNS4zMjA5IiB5MT0iODkuMzQ2NSIgeDI9IjM1LjMyMDkiIHkyPSIyMC4yMDkxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMwQzZERUIiLz4KPHN0b3Agb2Zmc2V0PSIwLjQ5IiBzdG9wLWNvbG9yPSIjMDY5RUI1Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwQ0Q4MCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";